import * as React from 'react';
import { connect } from 'react-redux';

import { FinancialWorkbook, PortalTextSubmissionDetails } from '../../Models/Api/strongbox.financialportal';
import { ApplicationState } from '../../Store';
import { GetFieldGuideEnabled } from '../../Store/AppSettings';
import { DownloadableFile } from '../../Utils/FileUtils';

import { FieldGuideWizard } from '../FieldGuide/FieldGuideWizard';

import { WorkbookRow, WorkbooksCard, WorkbooksSelection } from './WorkbooksCard';

type InjectedReduxState = {
    fieldGuideEnabled: boolean;
};

type WorkbooksCardContainerProps = {
    workbooks: (FinancialWorkbook | undefined)[];
    workspaceId: string;
    financialRecordId: string | undefined;
    financialRecordCreated: string | undefined;
    onDownload: (files: DownloadableFile[]) => void;
    text?: PortalTextSubmissionDetails;
};

type Props = InjectedReduxState & WorkbooksCardContainerProps;

export const WorkbooksCardContainerComponent: React.FC<Props> = (props): React.ReactElement => {
    const { fieldGuideEnabled, ...workbooksCardProps } = props;

    // The latest selection reported by the card; the wizard gets the rows checked at the moment it opens.
    const selection = React.useRef<WorkbooksSelection | undefined>(undefined);
    const [wizardWorkbooks, setWizardWorkbooks] = React.useState<WorkbookRow[] | undefined>(undefined);

    return (
        <>
            <WorkbooksCard
                {...workbooksCardProps}
                fieldGuideEnabled={fieldGuideEnabled}
                onSelectionChange={(latest: WorkbooksSelection) => { selection.current = latest; }}
                onSendToFieldguide={() => setWizardWorkbooks(selection.current?.checkedRows ?? [])}
            />
            {wizardWorkbooks && <FieldGuideWizard workbooks={wizardWorkbooks} onClose={() => setWizardWorkbooks(undefined)} />}
        </>
    );
};

export const WorkbooksCardContainer = connect<InjectedReduxState, {}, WorkbooksCardContainerProps, ApplicationState>(
    (appState: ApplicationState) => {
        return {
            fieldGuideEnabled: GetFieldGuideEnabled(appState),
        };
    }
)(WorkbooksCardContainerComponent);
